import React from "react";
import { createRoot } from "react-dom/client";

import { AppsSDKUIProvider } from "@openai/apps-sdk-ui/components/AppsSDKUIProvider";

import { ItineraryWidget } from "./itineraries";

document.querySelectorAll<HTMLElement>("[data-admin-itinerary-widget]").forEach((element) => {
  const payload = element.querySelector<HTMLScriptElement>("[data-itinerary-widget-payload]");
  if (!payload?.textContent) return;

  const toolOutput = JSON.parse(payload.textContent);

  createRoot(element).render(
    <React.StrictMode>
      <AppsSDKUIProvider>
        <ItineraryWidget toolOutputOverride={toolOutput} themeOverride="dark" />
      </AppsSDKUIProvider>
    </React.StrictMode>,
  );
});
